import type { Cycle, CycleCode, CycleScope } from "@/types";

export const CYCLE_SCOPE_LABEL: Record<CycleScope, string> = {
  PRIMAIRE: "Primaire",
  SECONDAIRE: "Secondaire",
  GLOBAL: "Global (les deux cycles)",
};

/** Codes de cycle visibles pour une portée donnée. */
export function cycleCodesForScope(scope: CycleScope): CycleCode[] {
  return scope === "GLOBAL" ? ["PRIMAIRE", "SECONDAIRE"] : [scope];
}

/** Identifiant du cycle portant ce code (chaîne vide s'il est inconnu). */
export function cycleIdOf(cycles: Cycle[], code: CycleCode): string {
  return cycles.find((c) => c.code === code)?.id ?? "";
}

/** Code du cycle portant cet identifiant. */
export function cycleCodeOf(cycles: Cycle[], cycleId: string): CycleCode | undefined {
  return cycles.find((c) => c.id === cycleId)?.code;
}

/** Identifiants des cycles visibles pour une portée donnée. */
export function cycleIdsForScope(scope: CycleScope, cycles: Cycle[]): string[] {
  const codes = cycleCodesForScope(scope);
  return cycles.filter((c) => codes.includes(c.code)).map((c) => c.id);
}

/** Filtre une collection d'éléments possédant un champ `cycleId`. */
export function filterByCycle<T extends { cycleId: string }>(rows: T[], allowedCycleIds: string[]): T[] {
  return rows.filter((row) => allowedCycleIds.includes(row.cycleId));
}
